<template>
    <section>
        <div v-if="postsCount" class="bg-white rounded-lg shadow">
            <div class="px-2 py-3">
                <h2 class="mb-3 px-3 font-medium">Your Latest Challenge</h2>
                <div class="flow-root p-4">
                    <ul role="list" class="-my-5 divide-gray-200 divide-y">
                        <li v-for="post in posts" class="first:pt-2 py-5">
                            <div class="relative rounded-lg focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-4">
                                <h3 class="text-gray-800 text-sm font-semibold">
                                    <Link :href="route('attachUserToChallenge', { post: post })" class="hover:underline focus:outline-none">
                                        <!-- Extend touch target to entire panel -->
                                        <span class="absolute inset-0" aria-hidden="true"></span>
                                        <div class="aspect-w-10 aspect-h-7 block p-0 w-full h-28 rounded-lg shadow shadow-inner transition duration-100 ease-in-out group-hover:brightness-90 group-hover:contrast-125 filter sm:overflow-hidden" v-html="post.featuredImageHtml"></div>
                                    </Link>
                                </h3>
                                <p class="line-clamp-2 mt-1 text-gray-600 text-sm">{{ post.text }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="px-4">
                    <Link :href="route('accepted.index')" class="flex items-center justify-center px-4 py-2 w-full text-gray-700 text-sm font-medium hover:bg-gray-50 bg-white border border-gray-300 rounded-md shadow-sm"> View all </Link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        postsCount() {
            if (!this.posts) return false
            return this.posts.length
        },
    },
    data() {
        return {
            posts: this.$page.props.acceptedChallenges,
        }
    },
}
</script>
